import { styled } from "@phntms/css-components";
import styles from "./styles.module.scss";

export const ModalContentWrapper = styled("div", {
  css: styles.modalContentWrapper,
});

export const ImgCol = styled("div", {
  css: styles.imgCol,
});

export const ImgWrapper = styled("div", {
  css: styles.imgWrapper,
});

export const ContentCol = styled("div", {
  css: styles.contentCol,
});

export const MemberName = styled("h3", {
  css: styles.name,
});

export const MemberJobTitle = styled("p", {
  css: styles.jobTitle,
});

export const MemberAboutMe = styled("div", {
  css: styles.aboutMe,
});
